import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { usePointAcopio } from "../../Context/PointAcopioContext";
import style from "../../assets/jss/disal-main/Layouts/Gerencia";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import ModalDelete from "../../Component/Modal/ModalDeletePointAcopio";
import ModalSuccess from "../../Component/Modal/ModalExitoPoints";
import FormPointAcopio from "../../Component/Form/PointAcopio";
import LoadingOverlay from "../../Component/Loading/LoadingOverlay";

const useStyles = makeStyles(style);

const PointAcopioContent = () => {
  const miningSites = JSON.parse(localStorage.getItem('miningSites'));
  const classes = useStyles();

  const { 
    miningSite,
    setMiningSite,
    selected,
    setSelected,
    nameFilter,
    setNameFilter,
    idFilter,
    setIdFilter,
    numberFilter,
    setNumberFilter,
    departmentFilter,
    setDepartmentFilter,
    points,
    setDeleteItem,
    loading,
    departments,
  } = usePointAcopio();


  const filterDisabled = miningSite === 0;

  const handleClickPoint = async (item) => {
    setSelected(item);
  };

  return (
    <div className={classes.content}>
      <Grid container className={classes.gerencia}>
        <Grid item xs={12} className={classes.filter}>
          <FormControl variant="outlined">
            <Select
              className={classes.filterSelectSmall}
              value={miningSite}
              onChange={(e) => {
                setMiningSite(e.target.value);
              }}
            >
              <MenuItem value={0}>Seleccione una planta</MenuItem>
              {miningSites.map((res, key) => {
                return (
                  <MenuItem key={key} value={res.id}>
                    {res.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <FormControl variant="outlined">
            <Paper className={classes.filterInput}>
              <InputBase
                className={classes.input}
                disabled={filterDisabled}
                value={idFilter}
                placeholder="Buscar por id"
                onChange={(e) => setIdFilter(e.target.value)}
              />
              <IconButton
                type="button"
                className={classes.iconButton}
                disabled={filterDisabled}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
            </Paper>
          </FormControl>
          <FormControl variant="outlined">
            <Paper className={classes.filterInputSmall}>
              <InputBase
                className={classes.input}
                disabled={filterDisabled}
                value={numberFilter}
                placeholder="Buscar por número"
                onChange={(e) => setNumberFilter(e.target.value)}
              />
              <IconButton
                type="button"
                className={classes.iconButton}
                disabled={filterDisabled}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
            </Paper>
          </FormControl>
          <FormControl variant="outlined">
            <Paper className={classes.filterInputSmall}>
              <InputBase
                className={classes.input}
                disabled={filterDisabled}
                value={nameFilter}
                placeholder="Buscar por nombre"
                onChange={(e) => setNameFilter(e.target.value)}
              />
              <IconButton
                type="button"
                className={classes.iconButton}
                disabled={filterDisabled}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
            </Paper>
          </FormControl>
          <FormControl variant="outlined">
            <Select
              className={classes.filterSelectSmall}
              disabled={filterDisabled}
              value={departmentFilter}
              placeholder="Buscar por tipo"
              onChange={(e) => setDepartmentFilter(e.target.value)}
            >
              <MenuItem value={0}>Seleccione una opción</MenuItem>
              {departments.map((res, key) => {
                return (
                  <MenuItem key={key} value={res.departmentId}>
                    {res.departmentDescription}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={4} className={classes.listAdd}>
          <h3 className={classes.title}>Lista de los Puntos</h3>
          <List className={classes.listGerencia}>
            {points.map((item, index) => (
              <ListItem
                button
                id={item.collectPointId}
                className={
                  classes.Listbutton +
                  (selected && selected.collectPointId === item.collectPointId ? " active-item" : null)
                }
                onClick={() => handleClickPoint(item)}
                key={index}
              >
                <ListItemText primary={item.pointNumber + ", " + item.collectPointDescription} />
                {selected && selected.collectPointId === item.collectPointId ? (
                  <button
                    id={item.collectPointId}
                    className={classes.iconClose}
                    onClick={() => setDeleteItem(item)}
                  >
                    <CloseIcon />
                  </button>
                ) : null}
              </ListItem>
            ))}
          </List>
          {miningSite === 0 ? null : (
            <button
              className={classes.iconMore}
              onClick={() => setSelected({
                collectPointId: "",
                pointNumber: "",
                collectPointDescription: "",
                departmentId: 0
              })}
            >
              <AddIcon />
            </button>
          )}
        </Grid>
        <Grid item xs={8} className={classes.formGerencia}>
          <h3 className={classes.title}>Datos del Punto</h3>
          {selected ? (
            <FormPointAcopio />
          ) : (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              No hay punto seleccionado
            </div>
          )}
        </Grid>
      </Grid>
      <ModalDelete />
      <ModalSuccess />
      <LoadingOverlay open={loading} message="Guardando punto de acopio..." />
    </div>
  );
}

export default PointAcopioContent;
